module.exports = __webpack_public_path__ + "moderate-a835039ce2d40556eb13c1b043da5f87.png";